import { useGlobalSearchParams } from 'expo-router';

export function useSafeGlobalSearchParams<T>() {
  const params = useGlobalSearchParams() as T;

  const cleanedParams = {} as T;
  for (const key in params) {
    if (params[key] !== 'undefined') {
      cleanedParams[key] = params[key];
    }
  }

  return cleanedParams;
}
